// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"66":"f394b02a","436":"a0e31388","715":"3356f28e","974":"29a7220b","980":"89e2fbb6"}[chunkId] + ".chunk.js");